<template lang="pug">
  .card.white
    p(v-html='card.text')
</template>
<script>
  export default {
    name: 'white-card',
    props: {
      card: {
        type: Object,
        required: true
      }
    }
  }
</script>
